<template>
  <img
    :src="require(`@/assets/img/${filename}`)"
    :alt="alt"
    :title="thetitle"
    />
</template>

<script>
export default {
  name: 'logo-partner',
  props: {
    filename: {
      type: String,
      default: 'zerocoma.png'
    },
    alt: {
      type: String,
      default: 'partner'
    },
    title: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      thetitle: this.title ? this.title : this.alt
    }
  },
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.filter-black{
  filter: invert(100%) sepia(2%) saturate(6%) hue-rotate(335deg) brightness(104%) contrast(99%);
}
.filter-white{
  filter: invert(0%) sepia(2%) saturate(6%) hue-rotate(335deg) brightness(104%) contrast(99%);
}
.filter-main{
  filter: invert(70%) sepia(94%) saturate(776%) hue-rotate(168deg) brightness(98%) contrast(91%);
}
</style>
